<style>
.hidden-checkbox {
  display: none;
}

.checked-image {
  border: 2px solid blue;
  /* Możesz dostosować styl obwódki */
}
</style>

<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header mb-0">
      <div class="row align-items-center mb-">
        <div class="col-md mb-0 mb-md-0">
          <h1 class="page-header-title">Strony Magico CMS</h1>
        </div>
        <div class="col-md-auto"></div>
      </div>
    </div>
    <div class="card">
      <div class="table-responsive">
        <table class="table table-lg table-bordered table-thead-bordered table-nowrap table-align-middle card-table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Id</th>
              <th scope="col">Adres WWW</th>
              <th scope="col">Ping</th>
              <th class="text-end"></th>
            </tr>
          </thead>

          <tbody>
            <template v-for="(item, index) in items">
              <tr :key="index">
                <th scope="row" rowspan="2">{{ index + 1 }}</th>
                <td>{{ item.client_id }}</td>
                <td><b>{{ item.site_url }}</b></td>
                <td>{{ item.ping_at }}</td>
                <td rowspan="2" class="text-end">
                  <a title="Przejdz do logowania" class="btn btn-secondary" target="_blank" :href="item.site_url+'/mpanel/login'">Przejdź</a>
                  <button title ="Synchronizuje konta użytkownków do cmsa" class="btn btn-primary" @click="clickSync(item)" v-if="item.refresh_token && isManager()">
                    Synchronizuj użytkowników
                  </button>
                  <button title="Synchronizuj widgety pagebuildera do sync" @click="syncPagebuilder(item)" class="btn btn-info" v-if="item.refresh_token && isManager()">
                    Pagebuilder
                  </button>
                  <button title="Rozłącza CMS od magico.pro" @click="clickUnAuthorize(item)" v-if="item.refresh_token && isOwner()"
                    class="btn btn-secondary">
                    Rozłacz
                  </button>
                  <button title="Podłącza CMS od magico.pro" @click="clickAuthorize(item)" v-if="!item.refres_token && isOwner()" class="btn btn-primary">
                    Połącz
                  </button>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <div style="max-width:60vw" class="d-flex flex-wrap gap-1">

                    <span v-for="user in users" :key="user.user_id" class="mb-1">
                      <label :alt="user.name" :title="user.name" style="text-align: center; cursor: pointer">
                        <input :disabled="!isManager()" type="checkbox" :value="user.user_id" v-model="item.users_json"
                          @change="saveUsers(item.site_id, item.users_json)" class="hidden-checkbox" />
                        <img :alt="user.name" :title="user.name" width="48" height="48" v-tooltip class="rounded-circle"
                          :src="'https://id.magico.pro/images/avatars/' + user.image" :class="{
                            'checked-image': item.users_json.includes(user.user_id),
                          }" />
                      </label>
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../../api/helpdesk-axios.js";
import MagicoModal from "../MagicoModal.vue";
import DeleteConfirm from "../DeleteConfirm.vue";

export default {
  name: "Index",
  components: {
    MagicoModal,
    DeleteConfirm,
  },
  data: function () {
    return {
      items: [],
      modalQr: false,
      qrCodeUrl: "",
      users: [],
      user_role: "guest",
    };
  },
  methods: {
    isOwner() {
      return this.user_role == "owner" || this.user_role == "admin";
    },
    isManager() {
      return this.user_role == "owner" || this.user_role == "manager" || this.user_role == "admin";
    },
    finduser(user_id) {
      let user = {};
      this.users.forEach((i) => {
        if (user_id == i.user_id) {
          user = i;
        }
      });
      return user;
    },
    clickSync(item) {
      var id = item.site_id;
      console.log("save token");
      axios.post("api/v1/site/" + id + "/syncUsers").then(function (response) {
        console.log(response.data);
        alert("Zsynchronizowano");
      });
    },
    saveUsers(site_id, items) {
      if (this.isManager()) {
        axios.post("api/v1/site/" + site_id + "/users", { users: items });
      }
    },
    clickUnAuthorize(item) {
      if (!this.isOwner) {
        return;
      }
      var id = item.site_id;
      console.log("save token");
      axios
        .put("api/v1/site/" + id, { data: { access_token: "", refresh_token: "" } })
        .then(function (response) {
          item.refresh_token = "";
          item.access_token = "";
        });
    },
    clickAuthorize(item) {
      if (!this.isOwner) {
        return;
      }
      const BASE_URL = process.env.MIX_APP_URL + "/sites";
      var state = (Math.random() + 1).toString(36).substring(7);
      localStorage.setItem("site." + state, item.site_url);
      localStorage.setItem("id." + state, item.site_id);
      window.location.href =
        item.site_url +
        "/api/oauth/authorize?client_id=cmsmagicopro&redirect_uri=" +
        BASE_URL +
        "&grant_type=authorize&response_type=code&state=" +
        state;
    },
    load: function () {
      let vm = this;
      axios.get("api/v1/site").then(function (response) {
        vm.items = response.data.data;
        vm.users = response.data.users;
      });
    },
    openQrcode: function (item) {
      let vm = this;
      axios
        .get("api/v1/group/" + item.group_id + "/qrcode", {
          responseType: "arraybuffer",
        })
        .then((response) => {
          vm.qrCodeUrl =
            "data:image/png;base64," +
            Buffer.from(response.data, "binary").toString("base64");
        });
      this.modalQr = true;
    },
    syncPagebuilder(item) {
      axios.get("api/v1/section/syncfromsite/" + item.site_id)
        .then(response => {
          alert("Synchronizacja pagebuildera zakończona");
        })
        .catch(error => {
          alert("Błąd pagebuildera synchronizacji");
        });
    },
    deleteGroup(group) {
      let vm = this;
      axios.delete("api/v1/group/" + group.group_id).then(function (response) {
        vm.load();
      });
    },
    saveToken(id, token) {
      var vm = this;
      console.log("save token");
      axios.put("api/v1/site/" + id, { data: token }).then(function (response) {
        console.log("save token, response ", response);
        vm.load();
        vm.$router.push("/sites");
      });
    },
    getToken(params) {
      var vm = this;
      const BASE_URL = process.env.MIX_APP_URL + "/sites";
      var oauth_code = params.get("code");
      var oauth_state = params.get("state");
      var site_url = localStorage.getItem("site." + oauth_state);
      var id = localStorage.getItem("id." + oauth_state);

      fetch(site_url + "api/oauth/token", {
        method: "POST",
        body:
          "grant_type=authorization_code&redirect_uri=" +
          BASE_URL +
          "&client_id=cmsmagicopro&code=" +
          oauth_code,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (resp) {
          // Return the response as JSON
          return resp.json();
        })
        .then(function (data) {
          // Log the API data
          console.log("token", data);
          vm.saveToken(id, data);
          localStorage.removeItem("id." + oauth_state);
          localStorage.removeItem("site." + oauth_state);
        })
        .catch(function (err) {
          console.log("something went wrong", err);
        });
    },
  },
  mounted() {
    this.user_role = this.$store.getters["app/role"];
    let params = new URLSearchParams(document.location.search.substring(1));
    var oauth_code = params.get("code");
    var oauth_state = params.get("state");

    if (oauth_code) {
      this.getToken(params);
    }
    if (!["owner", "manager", 'admin'].includes(this.$store.getters["app/role"])) {
      this.$router.push("/");
    }
    this.load();
  },
};
</script>
<style scoped>
.rounded-circle {
 opacity: 0.6;
}
.checked-image {
  opacity: 1;
  /* Możesz dostosować styl obwódki */
}
</style>